module.exports = __webpack_public_path__ + "static/media/hero.2f3d543c.webp";